<div class="container py-4">
  <h2>Checkout</h2>
  <p class="text-secondary">Aquí integraremos Izipay y billeteras (Yape/Plin).</p>

  <form class="row g-3">
    <div class="col-md-6">
      <label class="form-label small">Nombre / Empresa</label>
      <input class="form-control" placeholder="Ej. Clínica San Gabriel">
    </div>
    <div class="col-md-6">
      <label class="form-label small">Correo</label>
      <input type="email" class="form-control" placeholder="contacto@dominio.com">
    </div>
    <div class="col-md-6">
      <label class="form-label small">Teléfono</label>
      <input class="form-control" placeholder="+51 ...">
    </div>
    <div class="col-md-6">
      <label class="form-label small">Dirección</label>
      <input class="form-control" placeholder="Calle, distrito, ciudad">
    </div>
    <div class="col-12">
      <button class="btn btn-primary" type="button">Pagar</button>
    </div>
  </form>
</div>
